import React from 'react';
import { useTranslation } from 'react-i18next';
import { Carousel, Row, Col, Typography, Divider, Space, Button, Tabs, Image, Grid, Card, theme } from 'antd';
import type { CarouselRef } from 'antd/es/carousel';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper'; // 引入 Swiper 类型
import { Autoplay } from 'swiper/modules';
import type { TabsProps } from 'antd';
import '@/assets/styles/swiper.min.css';
import { GlobalOutlined, TeamOutlined, ShopOutlined, CustomerServiceOutlined } from '@ant-design/icons';
const { useToken } = theme;
import ProductSwiper from '../components/ProductSwiper';
import NewsPage from '../components/NewsPage';
import Svgmap from '../components/common/svgmap';
const { useBreakpoint } = Grid;
const { Title, Paragraph } = Typography;
import banner1 from '@/assets/images/banner202501.jpg';
import banner2 from '@/assets/images/banner202503.jpg';
import banner3 from '@/assets/images/banner202502.jpg';
import bgTest from '@/assets/images/banner041806.png';
import logoCompany01 from '@/assets/images/logo_company_01.png';
import logoCompany02 from '@/assets/images/logo_company_02.png';
import logoCompany03 from '@/assets/images/logo_company_03.png';
import logoCompany04 from '@/assets/images/logo_company_04.png';
import logoCompany05 from '@/assets/images/logo_company_05.png';
import logoCompany06 from '@/assets/images/logo_company_06.png';
import logoCompany07 from '@/assets/images/logo_company_07.png';
import SolutionIcon from '@/assets/icons/slogan1.svg';
import DevIcon from '@/assets/icons/slogan2.svg';
import TrophyIcon from '@/assets/icons/slogan3.svg';
import TeamIcon from '@/assets/icons/slogan4.svg';

import productTaiyo1 from '@/assets/images/product/brands/taiyo1.jpg';
// import productTaiyo2 from '@/assets/images/product/brands/taiyo2.png';
// import productTaiyo3 from '@/assets/images/product/brands/taiyo3.png';
import productTaiyo4 from '@/assets/images/product/brands/taiyo4.jpg';
import productTaiyo5 from '@/assets/images/product/brands/taiyo5.jpg';
import productTaiyo6 from '@/assets/images/product/brands/taiyo6.jpg';
import productTaiyo8 from '@/assets/images/product/brands/taiyo8.jpg';
import productTaiyo9 from '@/assets/images/product/brands/taiyo9.jpg';
import productELNA1 from '@/assets/images/product/brands/ELNA_HVHT.jpg';
import productELNA2 from '@/assets/images/product/brands/ELNA_RJF.jpg';
import productELNA3 from '@/assets/images/product/brands/ELNA_RTZ.jpg';
import productELNA4 from '@/assets/images/product/brands/ELNA_RVR.jpg';
import productELNA5 from '@/assets/images/product/brands/ELNA_RVT.jpg';
import productELNA6 from '@/assets/images/product/brands/ELNA_RYT.jpg';
import productHRS1 from '@/assets/images/product/brands/HRS_1.png';
import productHRS2 from '@/assets/images/product/brands/HRS_2.png';
import productHRS3 from '@/assets/images/product/brands/HRS_3.png';
import productHRS4 from '@/assets/images/product/brands/HRS_4.png';
import productHRS5 from '@/assets/images/product/brands/HRS_5.png';
import productHRS6 from '@/assets/images/product/brands/HRS_6.png';
import productHRS7 from '@/assets/images/product/brands/HRS_7.png';
import productHRS8 from '@/assets/images/product/brands/HRS_8.png';
import productProsemi1 from '@/assets/images/product/brands/Prosemi_1.png';
import productProsemi2 from '@/assets/images/product/brands/Prosemi_2.png';
import productProsemi3 from '@/assets/images/product/brands/Prosemi_3.png';
import productProsemi4 from '@/assets/images/product/brands/Prosemi_4.png';
import productProsemi5 from '@/assets/images/product/brands/Prosemi_5.png';
import productProsemi6 from '@/assets/images/product/brands/Prosemi_6.png';
import productProsemi7 from '@/assets/images/product/brands/Prosemi_7.png';
import productProsemi8 from '@/assets/images/product/brands/Prosemi_8.png';
import productProsemi9 from '@/assets/images/product/brands/Prosemi_9.png';
import productROHM1 from '@/assets/images/product/brands/ROHM_IC.png';
import productROHM2 from '@/assets/images/product/brands/ROHM_LED.png';
import productROHM3 from '@/assets/images/product/brands/ROHM_3.png';
import productROHM4 from '@/assets/images/product/brands/ROHM_4.png';
import productROHM5 from '@/assets/images/product/brands/ROHM_5.png';
import productROHM6 from '@/assets/images/product/brands/ROHM_6.png';
import productROHM7 from '@/assets/images/product/brands/ROHM_7.png';
import productROHM8 from '@/assets/images/product/brands/ROHM_8.png';
import productROHM9 from '@/assets/images/product/brands/ROHM_9.png';
import { ArrowRightOutlined } from '@ant-design/icons';
import QA1 from '@/assets/icons/QA1.svg';
import QAmlcc from '@/assets/icons/QA-mlcc.svg';
import QAinductor from '@/assets/icons/QA-inductor.svg';
const Home: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { token } = useToken();
  const carouselRef = React.useRef<CarouselRef>(null);
  const swiperRefs = React.useRef<{ [key: string]: SwiperType | null }>({});
  const screens = useBreakpoint();
  const slogans = [
    {
      title: '1',
      content: t('page.slogan.text1'),
      icon: <img className='icon-slogan' src={SolutionIcon} alt="Solution" />
    },
    {
      title: '2',
      content: t('page.slogan.text2'),
      icon: <img className='icon-slogan' src={DevIcon} alt="DevIcon" />
    },
    {
      title: '3',
      content: t('page.slogan.text3'),
      icon: <img className='icon-slogan' src={TrophyIcon} alt="Trophy" />
    },
    {
      title: '4',
      content: t('page.slogan.text4'),
      icon: <img className='icon-slogan' src={TeamIcon} alt="Team" />
    },
  ];

  // Swiperlogo 的定义
  const Swiperlogo = [
    {
      src: logoCompany01,
      padding: '0 30px',
      alt: 'TAIYO YUDEN - EETL代理电容器品牌'
    },
    {
      src: logoCompany02,
      padding: '0 30px',
      alt: 'ELNA - EETL代理电子元器件品牌'
    },
    {
      src: logoCompany03,
      padding: '0 30px',
      alt: 'HRS - EETL代理电子元器件品牌'
    },
    {
      src: logoCompany04,
      padding: '0 30px',
      alt: 'Prosemi - EETL代理电子元器件品牌'
    },
    {
      src: logoCompany05,
      padding: '0 30px',
      background: '#d80a30',
      alt: 'ROHM - EETL代理电子元器件品牌'
    },
    {
      src: logoCompany06,
      padding: '0 30px',
      alt: '信维通信 - EETL代理电子元器件品牌'
    },
    {
      src: logoCompany07,
      padding: '0 30px',
      alt: 'LKS - EETL代理电子元器件品牌'
    }
  ];

  React.useEffect(() => {
    if (i18n.language !== 'zh') {
      i18n.changeLanguage('zh');
    }
    handleAfterChange(0);
  }, [i18n]);

  const onChange = (key: string) => {
    const swiper = swiperRefs.current[key];
    if (swiper) {
      swiper.autoplay.start(); // 切換 Tab 時重新啓動自動循環
    }
  };

  const tab1Products = [
    { 
      src: productTaiyo1,
      name: t('product.Taiyo1'),
      company: 'Taiyo Yuden',
    },
    // { src: productTaiyo2,
    //   name: t('product.Taiyo2'),
    //   company: 'Taiyo Yuden',
    // },
    // { src: productTaiyo3,
    //   name: t('product.Taiyo3'),
    //   company: 'Taiyo Yuden',
    // },
    { src: productTaiyo4,
      name: t('product.Taiyo4'),
      company: 'Taiyo Yuden',
    },
    { src: productTaiyo5,
      name: t('product.Taiyo5'),
      company: 'Taiyo Yuden',
    },
    { src: productTaiyo6,
      name: t('product.Taiyo6'),
      company: 'Taiyo Yuden',
    },
    { src: productTaiyo8,
      name: t('product.Taiyo8'),
      company: 'Taiyo Yuden',
    },
    { src: productTaiyo9,
      name: t('product.Taiyo9'),
      company: 'Taiyo Yuden',
    }
  ];
  
  const tab2Products = [
    { 
      src: productELNA1,
      name: 'HV、HT',
      company: 'ELNA',
    },
    { src: productELNA2,
      name: 'RJF',
      company: 'ELNA',
    },
    { src: productELNA3,
      name: 'RTZ',
      company: 'ELNA',
    },
    { src: productELNA4,
      name: 'RVR',
      company: 'ELNA',
    },
    { src: productELNA5,
      name: 'RVT',
      company: 'ELNA',
    },
    { src: productELNA6,
      name: 'RYT',
      company: 'ELNA',
    }
  ];
  
  const tab3Products = [
    { 
      src: productHRS1,
      name: '12G-SDI规格对应',
      company: 'HRS',
    },
    { src: productHRS2,
      name: 'MT金属套管内置防水光纤连接器',
      company: 'HRS',
    },
    { src: productHRS3,
      name: 'Multi RF对应',
      company: 'HRS',
    },
    { src: productHRS4,
      name: 'Zero Screw 端子台',
      company: 'HRS',
    },
    { src: productHRS5,
      name: '插入即锁适合自动化组装',
      company: 'HRS',
    },
    { src: productHRS6,
      name: '高速传输对应',
      company: 'HRS',
    },
    { src: productHRS7,
      name: '抗振设计浮动式连接器',
      company: 'HRS',
    },
    { src: productHRS8,
      name: '新一代标准以太网连接器',
      company: 'HRS',
    },
  ];

  const tab4Products = [
    { 
      src: productProsemi1,
      name: '表面贴片自恢复保险丝',
      company: 'PROSEMI',
    },
    { src: productProsemi2,
      name: '方块保险丝',
      company: 'PROSEMI',
    },
    { src: productProsemi3,
      name: '高速半导体保险丝',
      company: 'PROSEMI',
    },
    { src: productProsemi4,
      name: '功率二极管',
      company: 'PROSEMI',
    },
    { src: productProsemi5,
      name: '光伏专用保险丝',
      company: 'PROSEMI',
    },
    { src: productProsemi6,
      name: '陶瓷管保险丝',
      company: 'PROSEMI',
    },
    { src: productProsemi7,
      name: '陶瓷气体放电管',
      company: 'PROSEMI',
    },
    { src: productProsemi8,
      name: '维修开关系列保险丝',
      company: 'PROSEMI',
    },
    { src: productProsemi9,
      name: '英规熔断器',
      company: 'PROSEMI',
    },
  ];

  const tab5Products = [
    { 
      src: productROHM1,
      name: 'IC',
      company: 'ROHM',
    },
    { src: productROHM2,
      name: 'LED',
      company: 'ROHM',
    },
    { src: productROHM3,
      name: '传感器',
      company: 'ROHM',
    },
    { src: productROHM4,
      name: '电阻',
      company: 'ROHM',
    },
    { src: productROHM5,
      name: '二极管',
      company: 'ROHM',
    },
    { src: productROHM6,
      name: '功率半导体',
      company: 'ROHM',
    },
    { src: productROHM7,
      name: '激光二极管',
      company: 'ROHM',
    },
    { src: productROHM8,
      name: '晶体管',
      company: 'ROHM',
    },
    { src: productROHM9,
      name: '钽电容器',
      company: 'ROHM',
    },
  ];
  
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'TAIYO YUDEN',
      children: (
        <ProductSwiper
          products={tab1Products}
          onSwiper={(swiper) => (swiperRefs.current['1'] = swiper)} // 存儲 Swiper 實例
        />
      ),
    },
    {
      key: '2',
      label: 'ELNA',
      children: (
        <ProductSwiper
          products={tab2Products}
          onSwiper={(swiper) => (swiperRefs.current['2'] = swiper)} // 存儲 Swiper 實例
        />
      ),
    },
    {
      key: '3',
      label: 'HRS',
      children: (
        <ProductSwiper
          products={tab3Products}
          onSwiper={(swiper) => (swiperRefs.current['3'] = swiper)} // 存儲 Swiper 實例
        />
      ),
    },
    {
      key: '4',
      label: 'PROSEMI',
      children: (
        <ProductSwiper
          products={tab4Products}
          onSwiper={(swiper) => (swiperRefs.current['4'] = swiper)} // 存儲 Swiper 實例
        />
      ),
    },
    {
      key: '5',
      label: 'ROHM',
      children: (
        <ProductSwiper
          products={tab5Products}
          onSwiper={(swiper) => (swiperRefs.current['5'] = swiper)} // 存儲 Swiper 實例
        />
      ),
    },
  ];

  const handleAfterChange = (current: number) => {
    const bannerTextElements = document.querySelectorAll('.banner-text');
    bannerTextElements.forEach((element, index) => {
      if (index === current) {
        element.classList.add('animate-fade-in-up');
      } else {
        element.classList.remove('animate-fade-in-up');
      }
    });
  };

  const solutions = [
    {
      title: "高可靠性元件",
      description: "常见问题解答，为您解决电子元器件相关疑惑。",
      icon: <img width={60} src={QA1} />,
      qaList: [
        {
          question: "什么是AEC-Q200?",
          answer: "面向汽车的电子零部件规格(事实上的行业标准) 设置了高温高湿、耐热、冲击、耐久性等支持高可靠性的规格。"
        }
      ],
      link: "/faq/aec-q200"
    },
    {
      title: "多层陶瓷电容器专区",
      description: "常见问题解答，为您解决电子元器件相关疑惑。",
      icon: <img width={60} src={QAmlcc} />,
      qaList: [
        {
          question: "如何选择合适的多层陶瓷电容器？",
          answer: "选择多层陶瓷电容器时，需要考虑电容值、额定电压、温度特性、尺寸等因素。具体可根据应用场景和性能要求来确定。"
        }
      ],
      link: "/faq/mlcc"
    },
    {
      title: "电感器专区",
      description: "常见问题解答，为您解决电子元器件相关疑惑。",
      icon: <img width={60} src={QAinductor} />,
      qaList: [
        {
          question: "电感器的主要参数有哪些？",
          answer: "电感器的主要参数包括电感量、额定电流、品质因数、直流电阻等，这些参数会影响电感器在电路中的性能。"
        }
      ],
      link: "/faq/inductor"
    }
  ];

  return (
    <div className="home-page">
      <Carousel
        autoplay={{ dotDuration: true }}
        autoplaySpeed={3800}
        ref={carouselRef}
        effect="fade"
        afterChange={handleAfterChange}
      >
        <div className="banner-home banner-1">
          <Image
            width={'100%'}
            preview={false}
            src={banner1}
            alt={`EETL - ${t("page.carousel.title")}`}
            placeholder={
              <Image
                preview={false}
                src={banner1}
              />
            }
          />
          
          <div className='banner-text banner-animal w-100' style={{ padding: '10px'}}>
            {i18n.language !== 'en' ? (
              <div>
                <div className='title'>{t('page.carousel.title')}</div>
                <div className='subtitle mt-10'>To become an excellent and trusted electronic components distributor and value - added service provider</div>
              </div>
            ) : (
              <div className='title'>ESCORT YOU<br/> WITH ADVANCED TECHNOLOGY</div>
            )}
          </div>
        </div>
        <div className="banner-home">
          <Image
            width={'100%'}
            preview={false}
            src={banner2}
            alt={`EETL - ${t("page.carousel.title2")}`}
            placeholder={
              <Image
                preview={false}
                src={banner2}
              />
            }
          />
          <div className='banner-text banner-animal'>
            <div>
              {i18n.language !== 'en' ? (
                <div>
                  <div className='title'>{t('page.carousel.title2')}</div>
                  <div className='subtitle'>ESCORT YOU WITH ADVANCED TECHNOLOGY</div>
                </div>
              ) : (
                <div className='title'>ESCORT YOU<br/> WITH ADVANCED TECHNOLOGY</div>
              )}
              <Paragraph className='font-size1'>{t('page.carousel.subtitle')}</Paragraph>
            </div>
          </div> 
        </div>
        <div className="banner-home banner-3">
          <Image
            width={'100%'}
            preview={false}
            src={banner3}
            alt={`EETL - ${t("page.carousel.title3")}`}
            placeholder={
              <Image
                preview={false}
                src={banner3}
              />
            }
          />
          <div className='banner-text banner-animal'>
            {i18n.language !== 'en' ? (
              <div>
                <div className='title'>{t('page.carousel.title3')}</div>
                <div className='subtitle mt-10'>Intelligent Research and Development, Collaborative Future.</div>
              </div>
            ) : (
              <div className='title'>ESCORT YOU<br/> WITH ADVANCED TECHNOLOGY</div>
            )}
          </div>
        </div>
      </Carousel>

      {/* slogan */}
      <div className='container'>
        <div className="slogan-area">
          <Row gutter={[24, 24]}>
            {slogans.map((slogan) => (
              <Col key={slogan.title} xs={12} md={6} className='text-center'>
                <Space size={20}>
                  {slogan.icon}
                  <div className='slogan-text'>{slogan.content}</div>
                </Space>
              </Col>
            ))}
          </Row>
        </div>
      </div>

      {/* 关于我们 */}
      <div className={`bg-img ${screens.md ? 'pt-40 pb-40' : 'pt-20 pb-20'}`}>
        <div className='container'>
          <div className='mb-30'>
            <Divider className='divider-text'>ABOUT US</Divider>
            <Title className='text-center text-primary' level={1}>{t('page.aboutUs.title')}</Title>
          </div>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <Paragraph className='text-paragraph text-indent'>{t('page.aboutUs.paragraph1')}</Paragraph>
            
            {/* 核心优势卡片 */}
            <Row gutter={screens.md ? [24, 24] : [12, 12]} className='mt-30'>
              <Col xs={24} sm={12} lg={12}>
                <Card 
                  hoverable 
                  className='advantage-card'
                  style={{ 
                    height: '100%',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className='advantage-icon'>
                    <GlobalOutlined style={{ fontSize: '2.5rem', color: token.colorPrimary }} />
                  </div>
                  <Title level={4}>{t('page.aboutUs.cards.global.title')}</Title>
                  <Paragraph className='font-size1' style={{lineHeight: '175%'}}>
                    {t('page.aboutUs.cards.global.content')}
                  </Paragraph>
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={12}>
                <Card 
                  hoverable 
                  className='advantage-card'
                  style={{ 
                    height: '100%',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className='advantage-icon'>
                    <TeamOutlined style={{ fontSize: '2.5rem', color: token.colorPrimary }} />
                  </div>
                  <Title level={4}>{t('page.aboutUs.cards.team.title')}</Title>
                  <Paragraph className='font-size1' style={{lineHeight: '175%'}}>
                    {t('page.aboutUs.cards.team.content')}
                  </Paragraph>
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={12}>
                <Card 
                  hoverable 
                  className='advantage-card'
                  style={{ 
                    height: '100%',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className='advantage-icon'>
                    <ShopOutlined style={{ fontSize: '2.5rem', color: token.colorPrimary }} />
                  </div>
                  <Title level={4}>{t('page.aboutUs.cards.layout.title')}</Title>
                  <Paragraph className='font-size1' style={{lineHeight: '175%'}}>
                    {t('page.aboutUs.cards.layout.content')}
                  </Paragraph>
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={12}>
                <Card 
                  hoverable 
                  className='advantage-card'
                  style={{ 
                    height: '100%',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className='advantage-icon'>
                    <CustomerServiceOutlined style={{ fontSize: '2.5rem', color: token.colorPrimary }} />
                  </div>
                  <Title level={4}>{t('page.aboutUs.cards.future.title')}</Title>
                  <Paragraph className='font-size1' style={{lineHeight: '175%'}}>
                    {t('page.aboutUs.cards.future.content')}
                  </Paragraph>
                </Card>
              </Col>
            </Row>
          </div>


          <div className='text-center mt-50 mb-30'>
            <Button color="primary" variant="outlined" className="button-normal-dark" shape="round" size="large" href="/aboutus" style={{width: '200px'}}>
              {t('common.seemore')}
            </Button>
          </div>
        </div>
      </div>
      
      <div className='pt-40 pb-40' style={{
        backgroundImage: `url(${bgTest})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to bottom, rgb(235 241 249), rgba(28, 39, 46, 0.4), #ffffff)', // 深色滤镜，可调整透明度
          pointerEvents: 'none', // 允许点击下层元素
        }} />
        <div className='container' style={{position: 'relative',zIndex: '1'}}>
          <div className='mb-30'>
            <Divider className='divider-text'>PRODUCT</Divider>
            <Title className='text-center' style={{fontWeight: 'normal',letterSpacing: '2px'}} level={2}>深耕行业，提供高品质电子元器件代理产品</Title>
          </div>
          <div className='brands-box'>
            <Swiper
              modules={[Autoplay]}
              spaceBetween={0}
              slidesPerView={'auto'}
              loop={true}
              speed={screens.xs ? 5000 : 10000} 
              centeredSlides={true}
              autoplay={{
                delay: 0,
                disableOnInteraction: false
              }}
            >
              {Swiperlogo.map((logoimg, index) => (
                <SwiperSlide key={index} style={{ width: 'auto', padding: logoimg.padding, background: logoimg.background }}>
                  <Image
                    className=''
                    preview={false}
                    src={logoimg.src}
                    alt={logoimg.alt}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {/* 产品展示 */}
          <div className='tabs-filter'>
            <div className='tabs-common productTabs-swiper mt-30'>
              <Tabs defaultActiveKey="1" type="card" className='tabs-card' centered size="large" items={items} onChange={onChange} />
            </div>
          </div>
        </div>
        <div className='text-center mt-50 mb-30'>
          <Button color="primary" variant="outlined" className="button-normal-dark" shape="round" size="large" href="/products" style={{width: '200px'}}>
            {t('common.seemore')}
          </Button>
        </div>
      </div>

      {/* 全球服务 */}
      <div className='pt-40 pb-40'>
        <Svgmap />
      </div>

      <div className={`bg-img ${screens.md ? 'pt-40 pb-60' : 'pt-20 pb-20'}`} id="FAQ">
        <div className='container pt-40 pb-40'>
          <div className='mb-50'>
            <Divider className='divider-text'>
            <span style={{fontFamily: 'PingFang SC, sans-serif' }}>Q&A</span>
            </Divider>
            <Title className='text-center text-primary' level={2}>
              Q & A 专区
            </Title>
          </div>
          <Row className='pb-30' gutter={[24, 24]} justify="center">
            {solutions.map((solution, index) => (
              <Col key={index} xs={24} sm={12} md={8}>
                <div
                  style={{
                    backgroundColor: '#252a3e',
                    padding: '20px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                    transition: 'transform 0.3s ease',
                    textAlign: 'center',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {solution.icon}
                  <Title level={4} className='text-white' style={{ marginTop: '16px' }}>
                    {solution.title}
                  </Title>
                  {solution.qaList && solution.qaList.map((qa, qaIndex) => (
                    <div className='mt-30' key={qaIndex} style={{ marginTop: '16px', textAlign: 'left' }}>
                      <Paragraph strong className='text-white' style={{ opacity: 0.9 }}>
                        Q: {qa.question}
                      </Paragraph>
                      <Paragraph className='text-white' style={{ opacity: 0.8}}>
                        A: {qa.answer}
                      </Paragraph>
                    </div>
                  ))}
                  <div className='text-right'>
                    <Link to={solution.link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ color: '#00d8ff', textDecoration: 'none', display: 'inline-block', marginTop: '16px' }}>
                      <Button type="link" icon={<ArrowRightOutlined />} iconPosition="end" style={{ color: '#00d8ff' }}>
                        更多
                      </Button>
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>

      {/* 新闻动态 */}
      <div className='pt-40 pb-40'>
        <div className='container'>
          <div className='mb-30'>
            <Divider className='divider-text'>NEWS</Divider>
            <Title className='text-center text-primary' level={2}>{t('common.news')}</Title>
          </div>
          <NewsPage viewMode="card" />
        </div>
      </div>
    </div>
  );
};

export default Home;
